export const state = {
    referenceValues: {},
};
